// Dry run (POST …/pipelines/:id/dry-run): the unsaved draft runs inline
// under a budget with no side effects and nothing dequeued — dataset / upload
// readers peek `sampleCount` documents instead of the whole batch.
import React, { useState } from 'react';

export default function DryRunPanel({ dry, onRun, hasCallInput, hasBatchInput }) {
  const [input, setInput] = useState('{"text": "fix the typo in the Save button label"}');
  const [sample, setSample] = useState(3);
  const r = dry?.result;
  return (
    <div className="cs-card" style={{ padding: 12, marginBottom: 10 }} data-nova-note={`Dry run card: runs the draft in-process with no side effects${hasBatchInput ? `, peeking ${sample} sample document(s) without consuming the batch` : ''}.${r ? ` Last dry run: ${r.blocks} blocks, ${r.modelCalls} model calls, ${r.ms} ms.` : ''}`}>
      <strong style={{ color: 'var(--text)', fontSize: 13 }}>Dry run — test without consuming anything</strong>
      <p className="cs-help" style={{ fontSize: 12, marginTop: 6 }}>
        Runs the draft here with no side effects: no webhook fires, nothing is written, no document leaves its queue.
        {hasCallInput ? ' The text below is the Call input (JSON or plain text).' : ''}
        {hasBatchInput ? ' Readers peek a sample instead of the whole batch.' : ''}
      </p>
      {hasCallInput && (
        <textarea className="cs-input" style={{ width: '100%', minHeight: 56, marginTop: 4, fontFamily: 'ui-monospace, monospace', fontSize: 12 }} value={input} onChange={(e) => setInput(e.target.value)} aria-label="sample request" />
      )}
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 6, flexWrap: 'wrap' }}>
        <button type="button" className="cs-btn cs-btn-outline cs-btn-sm" disabled={dry?.busy} onClick={() => onRun(input, sample)}>{dry?.busy ? 'Running…' : 'Dry run'}</button>
        {hasBatchInput && (
          <label className="cs-help" style={{ fontSize: 12, display: 'flex', gap: 6, alignItems: 'center', margin: 0 }}>
            sample
            <select className="cs-input" style={{ padding: '2px 6px', fontSize: 12 }} value={sample} onChange={(e) => setSample(Number(e.target.value))} aria-label="sample size">
              {[1, 3, 5, 10, 25].map((n) => <option key={n} value={n}>{n}</option>)}
            </select>
            document{sample === 1 ? '' : 's'}
          </label>
        )}
      </div>
      {dry?.error && <p className="cs-help" style={{ color: 'var(--danger, #e5484d)', fontSize: 12, marginTop: 6 }} role="alert">{dry.error}</p>}
      {r && (
        <div style={{ marginTop: 8 }}>
          <p className="cs-help" style={{ fontSize: 12, margin: 0 }}>
            {r.blocks} ran · {r.skipped} skipped · {r.modelCalls} model call{r.modelCalls === 1 ? '' : 's'} · {r.ms} ms
            {r.budget?.spent ? ` · $${Number(r.budget.spent).toFixed(4)}` : ''}
          </p>
          <pre className="cs-help" style={{ fontSize: 11.5, whiteSpace: 'pre-wrap', margin: '6px 0 0', maxHeight: 180, overflow: 'auto' }}>
            {JSON.stringify(r.value && Object.keys(r.value).length ? r.value : r.text ?? r.outputs, null, 2)}
          </pre>
          {r.outputs && (
            <details style={{ marginTop: 6 }}>
              <summary className="cs-help" style={{ fontSize: 12, cursor: 'pointer' }}>Every block&apos;s output</summary>
              <pre className="cs-help" style={{ fontSize: 11, whiteSpace: 'pre-wrap', maxHeight: 240, overflow: 'auto', margin: '4px 0 0' }}>{JSON.stringify(r.outputs, null, 2)}</pre>
            </details>
          )}
        </div>
      )}
    </div>
  );
}
